import {ModalComponents} from 'constants/Modals';

import PostChangeBackground from 'features/postGenerator/modals/PostChangeBackground/PostChangeBackground';
import TemplateStyle from 'features/postGenerator/modals/TemplateStyle/TemplateStyle';

import {AssignPageEditor} from './Modals/AssignPageEditor/AssignPageEditor';
import AssignPub from './Modals/AssignPub/AssignPub';
import {BeerRemoveSuccess} from './Modals/BeerRemoveSuccess/BeerRemoveSuccess';
import CheckedBeerInfo from './Modals/CheckedBeerInfo/CheckedBeerInfo';
import ConfirmRemoveBeerFromTap from './Modals/ConfirmRemoveBeerFromTap/ConfirmRemoveBeerFromTap';
import DeactivatePageEditor from './Modals/DeactivatePageEditor/DeactivatePageEditor';
import DeleteAdminBeerConfirmation from './Modals/DeleteAdminBeerConfirmation/DeleteAdminBeerConfirmation';
import DeleteBeerPhoto from './Modals/DeleteBeerPhoto/DeleteBeerPhoto';
import DeleteBreweryPhoto from './Modals/DeleteBreweryPhoto/DeleteBreweryPhoto';
import DeleteEditorPhoto from './Modals/DeleteEditorPhoto/DeleteEditorPhoto';
import DeletePhoto from './Modals/DeletePhoto/DeletePhoto';
import DeletePubPagePhoto from './Modals/DeletePubPagePhoto/DeletePubPagePhoto';
import DeleteUserPhoto from './Modals/DeleteUserPhoto/DeleteUserPhoto';
import EditBeer from './Modals/EditBeer/EditBeer';
import {ForgotPassword} from './Modals/ForgotPassword/ForgotPassword';
import InvitePageEditor from './Modals/InvitePageEditor/InvitePageEditor';
import LogoutConfirmation from './Modals/LogoutConfirmation/LogoutConfirmation';
import RegistrationSuccess from './Modals/RegistrationSuccess/RegistrationSuccess';
import RemoveMyBeer from './Modals/RemoveMyBeer/RemoveMyBeer';
import ResetPassword from './Modals/ResetPassword/ResetPassword';
import UnassignPageEditor from './Modals/UnassignPageEditor/UnassignPageEditor';
import UnassignPub from './Modals/UnassignPub/UnassignPub';
import UploadPhoto from './Modals/UploadPhoto/UploadPhoto';

export const ModalObject: {[key: string]: JSX.Element} = {
  [ModalComponents.DELETE_PHOTO]: <DeletePhoto />,
  [ModalComponents.RESET_PASSWORD]: <ResetPassword />,
  [ModalComponents.REGISTRATION_SUCCESS]: <RegistrationSuccess />,
  [ModalComponents.UPLOAD_PHOTO]: <UploadPhoto />,
  [ModalComponents.DELETE_BREWERY_PHOTO]: <DeleteBreweryPhoto />,
  [ModalComponents.DELETE_PUB_PHOTO]: <DeletePubPagePhoto />,
  [ModalComponents.INVITE_PAGE_EDITOR]: <InvitePageEditor />,
  [ModalComponents.DEACTIVATE_PAGE_EDITOR]: <DeactivatePageEditor />,
  [ModalComponents.DELETE_EDITOR_PHOTO]: <DeleteEditorPhoto />,
  [ModalComponents.DELETE_USER_PHOTO]: <DeleteUserPhoto />,
  [ModalComponents.DELETE_BEER_PHOTO]: <DeleteBeerPhoto />,
  [ModalComponents.UNASSIGN_PAGE_EDITOR]: <UnassignPageEditor />,
  [ModalComponents.CHECKED_BEER_INFO]: <CheckedBeerInfo />,
  [ModalComponents.EDIT_BEER]: <EditBeer />,
  [ModalComponents.REMOVE_MY_LIST_BEER]: <RemoveMyBeer />,
  [ModalComponents.REMOVE_BEER_FROM_TAP_CONFIRMATION]: <ConfirmRemoveBeerFromTap />,
  [ModalComponents.REMOVE_BEER_SUCCESSFULLY]: <BeerRemoveSuccess />,
  [ModalComponents.LOGOUT_CONFIRMATION]: <LogoutConfirmation />,
  [ModalComponents.TEMPLATE_STYLE]: <TemplateStyle />,
  [ModalComponents.POST_CHANGE_BACKGROUND]: <PostChangeBackground />,
  [ModalComponents.DELETE_ADMIN_BEER_CONFIRMATION]: <DeleteAdminBeerConfirmation />,
  [ModalComponents.FORGOT_PASSWORD]: <ForgotPassword />,
  [ModalComponents.ASSIGN_PAGE_EDITOR]: <AssignPageEditor />,
  [ModalComponents.ASSIGN_PUB]: <AssignPub />,
  [ModalComponents.UNASSIGN_PUB]: <UnassignPub />,
};
